import { render, staticRenderFns } from "./DesignViewer.vue?vue&type=template&id=fd129bbc"
import script from "./DesignViewer.vue?vue&type=script&lang=js"
export * from "./DesignViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports